import React from 'react';

const PrimaryIndustryFilterIcon = (props: any) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8 17H3V3H15V7.5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M7 17V12H9.5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M6.5 6.5H11M6.5 9H10" strokeLinecap="round" strokeWidth="1.5" />
      <path
        d="M18.7876 14.6672L16.1697 17.2858C16.1019 17.3537 16.0214 17.4076 15.9327 17.4443C15.8441 17.4811 15.749 17.5 15.6531 17.5C15.5571 17.5 15.4621 17.4811 15.3734 17.4443C15.2848 17.4076 15.2042 17.3537 15.1364 17.2858L12 14.1522V10.5H15.6512L18.7876 13.6372C18.9237 13.7741 19 13.9592 19 14.1522C19 14.3452 18.9237 14.5303 18.7876 14.6672V14.6672Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13.9141 12.4165H13.9179"
        stroke="#2D2D2D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default PrimaryIndustryFilterIcon;
